module.exports = __webpack_public_path__ + "img/pacific-standard.e63407ed.png";